import { Col, Row } from "antd"

export function NameValueRow({
    Name,
    Value,
    bold,
    strike,
    children,
}: {
    Name: string | undefined | null
    Value?: string | number | undefined | null | JSX.Element | (() => JSX.Element)
    bold?: boolean
    strike?: boolean
    children?: React.ReactNode
}): JSX.Element {
    if ((Value === undefined || Value === null) && !children) return <></>
    
    let DisplayValue=undefined
    if (Value) {
         DisplayValue = (): JSX.Element => {
            if (strike) {
                if (typeof Value === "function") {
                    return Value()
                } else if (bold) {
                    return (
                        <div>
                            <del>
                                <b>{Value}</b>
                            </del>
                        </div>
                    )
                } else {
                    return (
                        <div>
                            <del>{Value}</del>
                        </div>
                    )
                }
            } else {
                if (typeof Value === "function") {
                    return Value()
                } else if (bold) {
                    return (
                        <div>
                            <b>{Value}</b>
                        </div>
                    )
                } else {
                    return <div>{Value}</div>
                }
            }
        }
    }
        return (
            <Row className="mt05">
                <Col span={5}>
                    {bold && (
                        <div>
                            
                            <b>{Name}:</b>
                        </div>
                    )}
                    {!bold && <div> {Name}:</div>}
                </Col>
                <Col span={12}>
                    {DisplayValue? <DisplayValue />:children}
                </Col>
            </Row>
        )
   
}